import { render, staticRenderFns } from "./embededVideoCard.vue?vue&type=template&id=71fb7221&scoped=true"
import script from "./embededVideoCard.vue?vue&type=script&lang=js"
export * from "./embededVideoCard.vue?vue&type=script&lang=js"
import style0 from "./embededVideoCard.vue?vue&type=style&index=0&id=71fb7221&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71fb7221",
  null
  
)

export default component.exports